module.exports = __webpack_public_path__ + "static/media/edit.e4e6abe8.svg";